(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('ClientCreditsCreateModalController', ClientCreditsCreateModalController);

        ClientCreditsCreateModalController.$inject = ['$uibModalInstance', 'ClientService', 'InvoicesService', 'SellerService', 'clientCredits', 'toastr'];

    function ClientCreditsCreateModalController($uibModalInstance, ClientService, InvoicesService, SellerService, clientCredits, toastr) {
        var vm = this;

        // Form
        vm.search           = null;
        vm.user_id          = null;
        vm.seller_id        = null;
        vm.sellerSelected   = null;
        vm.date             = null;
        vm.currency         = null;
        vm.total            = null;
        vm.contact_name     = null;
        vm.contact_email    = null;
        vm.description      = null;
        vm.dateOptions      = {
            autoUpdateInput: true,
            autoApply: true,
            singleDatePicker: true,
            locale: {
                format: 'DD/MM/YYYY',
                cancelLabel: 'Close'
            }
        };

        // Methods
        vm.getCurrencies    = getCurrencies;
        vm.getSellers       = getSellers;
        vm.getLastInvoice   = getLastInvoice;
        vm.formatDate       = formatDate;
        vm.searchClients    = searchClients;

        // Modal
        vm.ok               = ok;
        vm.cancel           = cancel;

        function formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        }

        activate();

        function activate() {
            vm.getCurrencies();
            vm.getSellers();
        }

        function ok () {
            let query = {};
            query['user_id'] = vm.user_id;
            query['seller_id'] = vm.sellerSelected.id;
            query['contact_name'] = vm.contact_name;
            query['contact_email'] = vm.contact_email;
            query['currency'] = vm.currency;
            query['total'] = vm.total;
            query['description'] = vm.description;

            // query['date'] = vm.date;
            ClientService.storeCredit(query).then(function(response, status) {
                if(response.status !== 200 && response.status !== 201) {
                    toastr.error("An error ocurred on save this Client Credit");
                } else {
                    toastr.success("Client Credit successfully saved!");
                    clientCredits.getByFilter();
                }
                $uibModalInstance.close();
            }).catch(function(err) {
                toastr.error('Error:'+err);
            });
            $uibModalInstance.close();
        }

        function getCurrencies () {
            InvoicesService.getPaymentCurrencies().then(function (response) {
                vm.currencies = response.data;
            });
        }

        function getSellers () {
            SellerService.getAll().then(function(response) {
                vm.sellers = response.data;
            }).catch(function(err) {
            });
        }

        function getLastInvoice () {
            InvoicesService.getLastInvoice(vm.user_id).then(function (response) {
                vm.contact_name = response.data.contact_name;
                vm.contact_email = response.data.contact_email;
                vm.seller_id = response.data.seller_id;
                vm.sellerSelected = {
                    id: response.data.seller_id,
                    name: response.data.seller_name
                };
            });
        }

        function searchClients () {
            let query = {};
            query['search'] = vm.search;
            ClientService.listClients(query).then(function(response) {
                vm.users = response.data;
            });
        }        

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();